import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ServicesMain = () => {
    const [services, setServices] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedService, setSelectedService] = useState(null);
    const [selectedTab, setSelectedTab] = useState(null);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/services/`)
            .then(response => {
                setServices(response.data);
                // Set first tab as default
                const grouped = response.data.reduce((acc, service) => {
                    const catId = service.category ? service.category.id : 'no-category';
                    if (!acc[catId]) {
                        acc[catId] = true;
                    }
                    return acc;
                }, {});
                const firstTab = Object.keys(grouped)[0];
                setSelectedTab(firstTab);
            })
            .catch(error => {
                console.error('Error fetching services:', error);
            });
    }, []);

    const handleCardClick = (service) => {
        setSelectedService(service);
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedService(null);
    };

    // Group services by category
    const groupedServices = services.reduce((acc, service) => {
        const catId = service.category ? service.category.id : 'no-category';
        if (!acc[catId]) {
            acc[catId] = {
                category: service.category || { name: 'Other Services', description: '' },
                services: []
            };
        }
        acc[catId].services.push(service);
        return acc;
    }, {});

    // Get current tab services
    const currentTabServices = selectedTab ? groupedServices[selectedTab] : null;

    return (
        <React.Fragment>
            <style>
                {`
                .services-page {
                    background: #ffffff;
                    min-height: 100vh;
                }
                .service-card {
                    border: none;
                    border-radius: 16px;
                    overflow: hidden;
                    background: #ffffff;
                    box-shadow: 0 4px 16px rgba(0,0,0,0.1);
                    transition: transform 0.2s, box-shadow 0.2s;
                    position: relative;
                    min-height: 340px;
                    display: flex;
                    flex-direction: column;
                    margin-bottom: 1.5rem;
                    cursor: pointer;
                }
                .service-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 8px 24px rgba(161,79,31,0.15);
                }
                .service-card-img-wrapper {
                    position: relative;
                    overflow: hidden;
                    height: 180px;
                    background: #f5f5f5;
                }
                .service-card-img-wrapper img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.2s;
                }
                .service-card:hover .service-card-img-wrapper img {
                    transform: scale(1.05);
                }
                .service-card-title {
                    font-size: 1.1rem;
                    font-weight: 700;
                    margin-bottom: 0.5rem;
                    color: #A14D1F;
                    letter-spacing: 0.3px;
                }
                .service-card-text-preview {
                    color: #555;
                    font-size: 0.95rem;
                    font-weight: 500;
                    margin-bottom: 0.8rem;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    line-height: 1.4;
                }
                .service-card-btn {
                    margin-top: auto;
                    background: #A14D1F;
                    color: #fff;
                    border-radius: 8px;
                    padding: 0.6rem 1.5rem;
                    font-weight: 600;
                    border: none;
                    font-size: 0.95rem;
                    transition: background 0.2s;
                    cursor: pointer;
                }
                .service-card-btn:hover {
                    background: #8A3B17;
                }
                @media (max-width: 1200px) {
                    .service-card-img-wrapper { height: 150px; }
                    .service-card { min-height: 300px; }
                }
                @media (max-width: 992px) {
                    .service-card-img-wrapper { height: 130px; }
                    .service-card { min-height: 280px; }
                }
                /* Modal styles */
                .service-modal-backdrop {
                    position: fixed;
                    top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0,0,0,0.5);
                    z-index: 1000;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .service-modal-card {
                    background: #fff;
                    border-radius: 12px;
                    box-shadow: 0 10px 40px rgba(0,0,0,0.2);
                    max-width: 1000px;
                    width: 95vw;
                    max-height: 80vh;
                    display: flex;
                    flex-direction: row;
                    overflow: hidden;
                    animation: slideIn 0.3s ease-out;
                    position: relative;
                }
                .service-modal-img {
                    width: 55%;
                    min-width: 350px;
                    height: 100%;
                    object-fit: cover;
                    background: #f5f5f5;
                    display: block;
                }
                .service-modal-content {
                    flex: 1;
                    padding: 40px 30px;
                    display: flex;
                    flex-direction: column;
                    overflow-y: auto;
                }
                .service-modal-title {
                    font-size: 1.5rem;
                    font-weight: 700;
                    color: #A14D1F;
                    margin-bottom: 1rem;
                }
                .service-modal-desc {
                    color: #555;
                    font-size: 1rem;
                    line-height: 1.6;
                    font-weight: 500;
                }
                @keyframes slideIn {
                    from { 
                        transform: translateY(-50px);
                        opacity: 0;
                    }
                    to { 
                        transform: translateY(0);
                        opacity: 1;
                    }
                }
                .service-modal-close {
                    position: absolute;
                    top: 15px;
                    right: 15px;
                    font-size: 2.5rem;
                    color: #A14D1F;
                    background: none;
                    border: none;
                    cursor: pointer;
                    z-index: 2;
                    font-weight: bold;
                    transition: color 0.2s;
                    padding: 0;
                    width: 50px;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    line-height: 1;
                }
                .service-modal-close:hover {
                    color: #8A3B17;
                }
                @media (max-width: 900px) {
                    .service-modal-card {
                        flex-direction: column;
                        max-width: 90vw;
                    }
                    .service-modal-img {
                        width: 100%;
                        height: 280px;
                        min-width: 0;
                    }
                    .service-modal-content {
                        padding: 30px 25px;
                    }
                    .service-modal-title {
                        font-size: 1.3rem;
                    }
                    .service-modal-close {
                        font-size: 2rem;
                        width: 40px;
                        height: 40px;
                    }
                }
                .category-section {
                    margin-bottom: 2.5rem;
                }
                .category-title {
                    color: #A14D1F;
                    font-weight: 700;
                    font-size: 1.8rem;
                    margin-bottom: 0.8rem;
                    text-align: center;
                }
                .category-description {
                    color: #555;
                    font-size: 1rem;
                    text-align: center;
                    max-width: 700px;
                    margin: 0 auto 2rem;
                    line-height: 1.5;
                }
                .service-tabs {
                    display: flex;
                    justify-content: center;
                    gap: 0.8rem;
                    flex-wrap: wrap;
                    margin-bottom: 2.5rem;
                    padding: 1.5rem 0;
                }
                .service-tab-btn {
                    padding: 0.7rem 1.5rem;
                    border: 2px solid #A14D1F;
                    background: #ffffff;
                    color: #A14D1F;
                    border-radius: 8px;
                    font-weight: 600;
                    font-size: 0.95rem;
                    cursor: pointer;
                    transition: all 0.2s;
                    letter-spacing: 0.3px;
                }
                .service-tab-btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(161,79,31,0.15);
                }
                .service-tab-btn.active {
                    background: #A14D1F;
                    color: #fff;
                    box-shadow: 0 4px 12px rgba(161,79,31,0.3);
                }
                `}
            </style>
            <section className="py-5 services-page">
                <div className="container">
                    <div className="mb-4 row justify-content-center">
                        <div className="text-center col-12">
                            <h2 style={{
                                color: '#A14D1F',
                                fontWeight: 900,
                                fontSize: '48px',
                                letterSpacing: '1.2px',
                                marginBottom: '8px',
                            }}>Our Premium Services</h2>
                            <p style={{
                                color: '#4A2F24',
                                fontSize: '1.05rem',
                                maxWidth: 600,
                                margin: '0 auto',
                                letterSpacing: '0.3px',
                                marginBottom: '1.5rem',
                            }}>
                                Embark on your filmmaking journey right here at the very heart of the craft!
                            </p>
                        </div>
                    </div>

                    {/* Service Tabs */}
                    <div className="service-tabs">
                        {Object.entries(groupedServices).map(([catId, group]) => (
                            <button
                                key={catId}
                                className={`service-tab-btn ${selectedTab === catId ? 'active' : ''}`}
                                onClick={() => setSelectedTab(catId)}
                            >
                                {group.category.name}
                            </button>
                        ))}
                    </div>

                    {/* Services for Selected Tab */}
                    {currentTabServices && (
                        <div className="category-section">
                            <h3 className="category-title">{currentTabServices.category.name}</h3>
                            <p className="category-description">{currentTabServices.category.description}</p>
                            <div className="row">
                                {currentTabServices.services.map((service) => (
                                    <div key={service.id} className="col-xl-4 col-lg-4 wow fadeInLeft" data-wow-delay="100ms">
                                        <div className="service-card" onClick={() => handleCardClick(service)}>
                                            <div className="service-card-img-wrapper">
                                                <img src={service.image} alt={service.Alt || service.title} />
                                            </div>
                                            <div style={{ padding: '1.2rem', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                                <h3 className="service-card-title">{service.title}</h3>
                                                <p className="service-card-text-preview">{service.description}</p>
                                                <button className="service-card-btn">Learn More</button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
                {modalOpen && selectedService && (
                    <div className="service-modal-backdrop" onClick={handleCloseModal}>
                        <div
                            className="service-modal-card"
                            onClick={e => e.stopPropagation()}
                        >
                            <button className="service-modal-close" onClick={handleCloseModal}>&times;</button>
                            <img src={selectedService.image} alt={selectedService.Alt || selectedService.title} className="service-modal-img" />
                            <div className="service-modal-content">
                                <div className="service-modal-title">{selectedService.title}</div>
                                <div className="text-justify service-modal-desc">{selectedService.description}</div>
                            </div>
                        </div>
                    </div>
                )}
            </section>
        </React.Fragment>
    );
};

export default ServicesMain;
